import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { SiumpAnalise } from '../models/siump-analise.model';

export interface FgtsSiumpRepository {
  analisarArquivo(arquivo: File): Observable<SiumpAnalise>;
}

export const FGTS_SIUMP_REPOSITORY = new InjectionToken<FgtsSiumpRepository>('FgtsSiumpRepository');
